import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import * as _ from 'lodash';
import { AppStateService } from 'src/app/modules/core/services/app-state.service';

import { VehicleActivity } from 'src/app/modules/shared/models/vehicle/vehicle-activity';
import { VehicleDeparture } from 'src/app/modules/shared/models/vehicle/vehicle-departure';
import { VehicleDeviation } from 'src/app/modules/shared/models/vehicle/vehicle-deviation';
import { ActivityPointListItem } from './activity-point-list-item';
import { VehicleTripInfoHelper } from './vehicle-trip-info.helper';
import { FeedbackTextComponent } from '../../../modules/shared/components/feedback-text/feedback-text.component';
import { TranslateModule } from '@ngx-translate/core';
import { DeviationTextComponent } from '../../../modules/shared/components/deviation-text/deviation-text.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { VehicleService } from '../vehicle.service';

@Component({
    selector: 'app-vehicle-trip-info',
    templateUrl: './vehicle-trip-info.component.html',
    styleUrls: ['./vehicle-trip-info.component.scss'],
    imports: [DeviationTextComponent, TranslateModule, NgClass, FeedbackTextComponent, AsyncPipe],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class VehicleTripInfoComponent implements OnChanges {
    private _appState = inject(AppStateService);
    private _vehicleService = inject(VehicleService);


    @Input() vehicleActivity: VehicleActivity;
    @Input() departureHistory: VehicleDeparture[];
    @Input() departureDeviation: VehicleDeviation;
    @Input() arrivalDeviation: VehicleDeviation;

    public items$ = this._vehicleService.activityPointListItem.asObservable();
    public showAll = false;
    public deviationMatched = false;


    constructor() { }

    ngOnChanges(simpleChanges: SimpleChanges) {
        this.updateList();
    }

    public toggleShowAll() {
        this.showAll = !this.showAll;
        this.updateList();
    }

    // Show timetable if there are any items, otherwise only current deviation.
    public get showTimetable(): boolean {
        if (this._vehicleService.activityPointListItem?.value.length > 0) {
            return true;
        }
        return false;
    }

    // vehicle activities is undefined until backend call i complete
    public get loadingTimeTable(): boolean {
        return this.vehicleActivity === undefined;
    }

    // backed returning null if there is no data
    public get noData(): boolean {
        return this.vehicleActivity == undefined;
    }

    // we get both deviation and vehicle activity data as expected but we are having trouble with matching the stops (with id or name)
    // the two data sources are to different
    public get matchingProblems(): boolean {
        return this._vehicleService.activityPointListItem?.value.length > 0 && !this.deviationMatched;
    }

    public updateList() {
        if (this.departureHistory !== undefined && this.departureDeviation) {
            this.departureDeviation.departures = this.departureHistory;
        }
        const itemsResponse = VehicleTripInfoHelper.getActivityPointItems(
            this.showAll,
            this.vehicleActivity,
            this.departureDeviation,
            this.arrivalDeviation,
            this._appState);

        this.deviationMatched = itemsResponse.deviationMatched;
        this._vehicleService.activityPointListItem.next(itemsResponse.items || []);
    }

}
